<template>
  <div>
    <v-app>
      <v-main>
        <v-card class="mx-auto" max-width="400">
          <v-card-title>登录</v-card-title>

          <v-card-text>
            <v-form v-model="valid">
              <v-text-field v-model="username" label="用户名" :rules="[rules.required]"></v-text-field>
              <v-text-field v-model="password" :append-icon="showPassword ? 'mdi-visibility' : 'mdi-visibility_off'"
                :type="showPassword ? 'text' : 'password'" label="密码" :rules="[rules.required, rules.min]"
                @click:append="showPassword = !showPassword"></v-text-field>
              <v-btn class="mt-4" block color="primary" :disabled="!valid" @click="login">
                登录
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-main>
    </v-app>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      password: '',
      showPassword: false,
      valid: false,
      rules: {
        required: value => !!value || '必填',
        min: value => value?.length >= 8 || '至少8位',
      }
    }
  },
  methods: {
    async login() {
      try {
        const response = await axios.post('http://localhost:8080/api/auth/login', {
          username: this.username,
          password: this.password
        });

        if (response.data) {
          this.$router.push('/home');
        } else {
          alert('用户名或密码错误');
        }
      } catch (error) {
        console.error('登录失败:', error);
        alert('登录失败，请重试');
      }
    }
  }
}  
</script>